export const classes = {
  bar: 'h-[7px]',
  previousFill: 'bg-accent-teal/80',
  grid: 'grid grid-cols-[auto_minmax(24px,1fr)_auto] gap-x-2 gap-y-1.5 items-center min-w-0 mt-auto pt-1',
  compact: 'flex flex-col gap-[3px]',
  previousTag: 'text-taupe-1 text-[10.5px] font-bold whitespace-nowrap',
  currentTag: 'text-taupe-2 text-[10.5px] font-bold whitespace-nowrap',
  previousValue: 'text-taupe-1 text-right text-[11.5px] font-semibold truncate',
  currentValue: 'text-taupe-3 text-right text-[11.5px] font-bold truncate',
};
